var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarouselIcon = function SvgCarouselIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    transform: "rotate(-180 17 17)",
    fill: "#F30000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.354 17.354a.5.5 0 0 0 0-.708l-3.182-3.182a.5.5 0 1 0-.707.708L23.293 17l-2.828 2.828a.5.5 0 1 0 .707.707l3.182-3.181ZM10 17.5h14v-1H10v1Z",
    fill: "#fff"
  })));
};
export default SvgCarouselIcon;